import type { Bubble } from "./reducer";

/**
 * Build a snapshot registry from existing bubbles for deduplication.
 * Used by store hydration and reconstruction paths to keep IDs consistent.
 */
export const deriveSnapshotRegistry = (bubbles: Bubble[]): Set<string> => {
	const registry = new Set<string>();
	for (const bubble of bubbles) {
		const metadata = bubble.metadata;
		if (metadata) {
			if (typeof metadata.blockId === "string") {
				registry.add(metadata.blockId);
				continue;
			}
			if (typeof metadata.toolId === "string") {
				registry.add(metadata.toolId);
			}
		}
	}
	return registry;
};
